import { useMsal } from '@azure/msal-react';
import { Box, Divider, ListItemIcon, ListItemText, Menu, MenuItem, Typography } from '@mui/material';
import { isMobileView, useAlerts, useFormCollection } from '@sis/react-library';
import { useState } from 'react';
import { commonRoutes } from '../shared/commonConstants';
import LogoutIcon from '@mui/icons-material/Logout';
import { EnvironmentDescription } from '../shared/EnvironmentDescription';
import { LayoutTopAppBarAvatar } from './LayoutTopAppBarAvatar';

export const LayoutTopAppBarRight = () => {

    const [anchorElUser, setAnchorElUser] = useState<null | HTMLElement>(null);

    const { instance, accounts } = useMsal();
    const { confirm } = useAlerts();
    const isMobile = isMobileView();

    const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorElUser(event.currentTarget);
    };

    const handleCloseUserMenu = () => {
        setAnchorElUser(null);
    };

    const { disableFormLeavePrompt } = useFormCollection();

    const handleLogout = () => {
        setAnchorElUser(null);
        confirm('Logout', 'Are you sure you want to logout?',
            async () => {
                // Don't prompt that changes have been made to any form open, the person has already confirmed to logout
                disableFormLeavePrompt();
                instance.logoutRedirect({
                    postLogoutRedirectUri: commonRoutes.login,
                })
            }
        )
    }

    const username = accounts && accounts.length > 0 ? accounts[0].name : '[not logged in]';

    return (
        <>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Box sx={{ marginTop: '2px' }}><EnvironmentDescription /></Box>
                {!isMobile &&
                    <Typography id="menu-username" sx={{ padding: '4px 8px 0 0' }}>{username}</Typography>
                }
                <LayoutTopAppBarAvatar onClick={handleOpenUserMenu} />
            </Box>
            <Menu
                sx={{ mt: '45px' }}
                id="menu-appbar"
                anchorEl={anchorElUser}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                keepMounted
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                open={Boolean(anchorElUser)}
                onClose={handleCloseUserMenu}
            >
                <Typography id="submenu-username" sx={{ padding: '10px 16px 10px 16px', fontWeight: 'bold' }}>{username}</Typography>
                <Divider sx={{ marginBottom: '10px' }} />
                <MenuItem onClick={handleLogout}>
                    <ListItemIcon>
                        <LogoutIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Logout</ListItemText>
                </MenuItem>
            </Menu>
        </>
    )
}
